import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";
import ProjectLogTab from "@/components/project/ProjectLogTab";

export default function LogPage() {
  const { project } = useProjectDetailContext();
  return <ProjectLogTab projectId={project.id} />;
}
